import React, { useEffect, useState } from 'react';
import Breadcrumbs from '../../components/BreadCrumbs';
import Pagination from '../../components/tables/pagination/Pagination';
import CustomLoading from '../../components/customLoading/CustomLoading';
import Table from '../../components/tables/Table';
import loaderImage from "../../assets/icons/part-logo.png";
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import { toast } from 'react-toastify';
import { getUserName } from '../../utils/localStoarege';
import { formatDateTime } from '../../utils/FormatDateTime';
import { getHudInvoiceApi } from '../../services/account/hud_invoice';


function AccountHudInvoice() {
    const [cardData, setCardData] = useState([]);

    const [tableData, setTableData] = useState({});

    const headers = [
        { label: "Name", key: "name" },
        { label: "Type", key: "type" },
        { label: "Amount", key: "amount" },
        { label: "Payment Mode", key: "mode" },
        { label: "Phone", key: "phone" },
        { label: "Date", key: "created_at" },
        { label: "Status", key: "status" },
        { label: "Transaction Number", key: "transaction_number" },
        { label: "Remark", key: "remark" },
    ];

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);


    const pageSize = 100;

    const fetchData = async () => {
        setLoading(true);
        try {
            let res = await getHudInvoiceApi(pageSize);
            if (res.status === 200) {
                setTableData(res.data);
            } else {
                toast.error("Unable to fetch Invoice");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Invoice:", error);
        } finally {
            setLoading(false);
        }
    };



    useEffect(() => {
        fetchData(getUserName());
    }, []);


    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    return (<>
        <Breadcrumbs items={[
            { name: 'Home' },
            { name: 'HUD Invoice' },
        ]} />
        {/* <div className="py-3">
            <StyledHeadingText text={"Invoice"} />
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 mt-2">
                {cardData.map((card, index) => (
                    <Card title={card.title} count={card.count} />
                ))}
            </div>
        </div> */}
        <div className="flex flex-row justify-between py-4 items-center">
            <StyledHeadingText text={"Invoice"} />
        </div>
        {
            loading ?
                <div className="flex w-full flex-row justify-center my-2">
                    <CustomLoading imageSrc={loaderImage} size={100} />
                </div>
                :
                <div className="mt-2">
                    <Table
                        headers={headers}
                        rows={tableData?.results?.map((item, index) => (
                            {
                                name: <p>{item.patient_name}</p>,
                                type: <p>{item.package_type}</p>,
                                amount: <p>{item.amount}</p>,
                                mode: <p>{item.mode}</p>,
                                phone: <p>{item.phone}</p>,
                                status: <p>{item.status}</p>,
                                created_at: <p>{formatDateTime(item.created_at)}</p>,
                                transaction_number: <p>{item.transaction_number}</p>,
                                remark: <p>{item.remark}</p>,
                            }
                        ))}
                    />
                </div>}
        {/* Table End */}
        {/* Pagination Begin */}
        {
            tableData.count !== 0 ?
                <div className="xl:pl-5 pl-0">
                    <Pagination
                        currentPage={currentPage}
                        totalPages={Math.ceil(tableData?.count / pageSize)}
                        pageSize={pageSize}
                        totalEntries={tableData?.count}
                        onPageChange={handlePageChange}
                        data={tableData}
                        setTableData={setTableData}
                    />
                </div> : <></>
        }
    </>);
}

export default AccountHudInvoice;